import { inject, Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { UserBackend } from "src/app/backend/api/user.backend";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { ErrorCodes } from "src/app/modules/maintenance/error-codes";
import {
  MemberAuthProviderResult,
  MemberAuthProviderService
} from "src/app/services/member-auth-provider/member-auth-provider.service";
import { SoftwareProduct } from "src/app/support/product";

@Injectable()
export class MemberAuthProviderPlatformService extends MemberAuthProviderService {
  readonly #userBackend = inject(UserBackend);
  readonly #product = inject(PRODUCT_TOKEN);

  async provide({
    accountNickName,
    domainSlug
  }: {
    domainSlug?: string;
    accountNickName?: string;
  } = {}): Promise<MemberAuthProviderResult> {
    const result: MemberAuthProviderResult = {};

    let productUsed: SoftwareProduct;

    switch (this.#product) {
      case SoftwareProduct.PMS:
      case SoftwareProduct.ROCKET:
      case SoftwareProduct.SNOOTS:
      case SoftwareProduct.ADMIN:
      case SoftwareProduct.PLATFORM:
      case SoftwareProduct.BOTMASTER: {
        productUsed = this.#product;
        break;
      }
      case SoftwareProduct.DROP_PAGE: {
        productUsed = SoftwareProduct.ROCKET;
        break;
      }
    }

    const member = await lastValueFrom(
      this.#userBackend.loadMemberByProduct({
        product: productUsed
      })
    );

    switch (true) {
      case !member: {
        result.error = ErrorCodes.ERR_016;
        break;
      }
      case !!member: {
        const tenant = await lastValueFrom(
          this.#userBackend.loadTenant(member.tenant)
        );

        result.tenant = tenant!;
        result.memberAuth = member!;
        break;
      }
    }

    return result;
  }
}
